<template>
  <v-container fluid>
    <v-expansion-panel style="margin-bottom: 50px;">
      <v-expansion-panel-content class="mycustomExpansionPanel">
        <template v-slot:actions>
          <v-icon large color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div>
            <v-icon color="primary">search</v-icon>
            <span class="pl-2 subheading">Custom Search Panel</span>
          </div>
        </template>
        <v-layout row wrap align-center>
          <v-flex>
            <v-card class="px-3">
              <v-layout row wrap align-center class="py-3">
                <v-flex xs12 sm12 md6>
                  <v-text-field
                    class="ma-2"
                    v-model="searchParam.college_code"
                    label="Search By College Code"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md6
                  style="margin-top:7px; margin-bottom:8px;"
                >
                  <v-text-field
                    class="ma-2"
                    v-model="searchParam.subject_code"
                    label="Search By Subject Code"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  style="margin-top:5px;margin-bottom:8px;"
                >
                  <v-layout justify-center row fill-height align-center>
                    <v-btn
                      color="primary"
                      large
                      dark
                      @click="validationForm('search')"
                    >
                      <v-icon center dark>search</v-icon>Search
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em;"
                class="elevation-0"
                v-if="pagination.totalItems > 0"
                >{{ pagination.totalItems }}</v-btn
              >
            </template>
            <v-card-text class="title">Incourse Wanting List</v-card-text>
          </v-badge>
        </v-card>
        <v-divider class="my-2" vertical></v-divider>

        <v-spacer />

        <v-btn color="primary" dark @click="validationForm('export_pdf')">
          Export As PDF
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
        <v-btn color="primary" dark @click="validationForm('export_xl')">
          Export As Excel
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
      </v-layout>
    </v-card>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="incourseWantingData.data"
      class="elevation-1"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      item-key="reg_no"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.item.rn }}
          </td>
          <td>
            {{ props.item.college_code }} - {{ props.item.college_name }}
          </td>
          <td>
            {{ props.item.subject_code }} - {{ props.item.subject_name }}
          </td>
          <td>
            {{ props.item.total_students }}
          </td>
          <td>
            {{ props.item.wanting_count || "-" }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import common_activities_get from "@/mixin/get_activities_time_publish";
import commonGet from "@/mixin/common_getters_mixin";
export default {
  mixins: [commonGet, common_activities_get],
  data() {
    return {
      current_privilege: "",
      college_user: "",
      loading: false,
      sl_count: 0,
      searchParam: {
        reg_no: "",
        confirm_status: "",
        display_type: "",
      },
      pagination: {
        rowsPerPage: 50,
        rowsPerPageItems: [50, 100, 150, 200, 250],
        page: 1,
        totalItems: 0,
      },
      headers: [
        { text: "SL", value: "rn", align: "left", sortable: false },
        { text: "College Code & Name", value: "", align: "left", sortable: false },
        { text: "Subject Code & Name", value: "", align: "left", sortable: false },
        {
          text: "Total Students",
          value: "",
          align: "left",
          sortable: false,
        },
        { text: "Wanting Students", value: "", align: "left", sortable: false },
      ],

      // pagination
      page: 1,
      per_page: 50,
      total: 0,

      items: [
        { status: "Confirmed", value: "1" },
        { status: "Pending", value: "0" },
      ],
    };
  },
  computed: {
    incourseWantingData() {
      return this.$store.getters.getIncourseWantingListAdmin;
    },
  },
  watch: {
    pagination() {
      this.waintingList();
    },
  },
  created() {
    
  },
  methods: {

    setLimit() {
      const { page, rowsPerPage, sortBy } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.exam_code = this.getLoggedInExam.code;
      this.searchParam.exam_year = this.getLoggedInYear.year;
      this.college_code = this.searchParam.college_code ? this.searchParam.college_code : "";
      this.subject_cod = this.searchParam.subject_code ? this.searchParam.subject_code : "";
      this.searchParam.display_type = this.searchParam.display_type
        ? this.searchParam.display_type
        : "";
    },

    waintingList() {
      try {
        if (this.searchParam.display_type) {
          this.loading = false;
        } else {
          this.loading = true;
        }
        this.setLimit();
        this.$store
          .dispatch("fetchIncourseWantingList", this.searchParam)

          .then((res) => {
            this.loading = false;

            this.sl_count = res.data.from || 0;

            this.pagination.totalItems = res.data.total || 0;
          });
      } catch (ex) {
        this.loading = false;
        console.log(ex);
      }
    },
    validationForm(type) {
      if (type == "search") {
        this.searchParam.display_type = "";
        this.waintingList();
      } else if (type == "export_pdf") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_pdf";
        this.waintingList();
      } else if (type == "export_xl") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_xl";
        this.waintingList();
      }

      // this.$validator.validateAll().then((isValid) => {
      //   if (isValid && item == 1) {
      //     this.candidateList(item);
      //   }
      //   if (isValid && item == 0) {
      //     this.MarkSheet();
      //   }
      // });
    },
  },
};
</script>
<style lang=""></style>
